const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export function loadRecaptchaScript() {
  if (!SITE_KEY || typeof document === "undefined") return;
  if (document.getElementById("recaptcha-v3")) return;
  const s = document.createElement("script");
  s.id = "recaptcha-v3";
  s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
}

export async function getRecaptchaToken(action) {
  if (!SITE_KEY || typeof window === "undefined" || !window.grecaptcha) return null;
  await new Promise((resolve) => window.grecaptcha.ready(() => resolve()));
  return window.grecaptcha.execute(SITE_KEY, { action });
}
